const emailTemplateKeys = {
    templateId: (templateId: string) => ['emailTemplate', templateId],
    templates: ['emailTemplates'],
};

export default emailTemplateKeys;
